import React from "react";
import { TorahAnyTimeLoaderTemplate } from "themes/application/torah-anytime/components";

function TorahAnyTimeLoader(props) {
    return <TorahAnyTimeLoaderTemplate {...props} />;
}

export default TorahAnyTimeLoader;
